import React from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'
import TextScrambler from 'react-scramble-text'
import 'react-scramble-text/dist/index.css'

const Experience = () => {
  const phrases = ["{Our Experiences}", "{Our Experiences} "]
  return (
    <section id="experience">
      <h5>The Skills I Have</h5>
      <h2><TextScrambler phrases={phrases} speed={5} pauseTime={1000}/></h2>

      <div className="container experience__container">
        <div className="experience__frontend">
            <h3>Frontend Development</h3>
              <div className='experience__content'>
                  <article className='experience__details'>
                    <BsPatchCheckFill className='experience__details-icon'/>
                    <div>
                      <h4>HTML</h4>
                      <small className='text-light'>Experienced</small>
                    </div>
                  </article>
                  <article className='experience__details'>
                    <BsPatchCheckFill className='experience__details-icon'/>
                    <div>
                      <h4>CSS</h4>
                      <small className='text-light'>Experienced</small>
                    </div>
                  </article>
                  <article className='experience__details'>
                    <BsPatchCheckFill className='experience__details-icon'/>
                    <div>
                      <h4>BOOTSTRAP</h4>
                      <small className='text-light'>intermediate</small>
                    </div>
                  </article>
                  <article className='experience__details'>
                    <BsPatchCheckFill className='experience__details-icon'/>
                    <div>
                      <h4>REACT JS</h4>
                      <small className='text-light'>intermediate</small>
                    </div>
                  </article>
                  <article className='experience__details'>
                    <BsPatchCheckFill className='experience__details-icon'/>
                    <div>
                      <h4>SASS</h4>
                      <small className='text-light'>intermediate</small>
                    </div>
                  </article>
              </div>
        </div>
        {/* END OF FRONTEND */}
        <div className="experience__backend">
            <h3>Backend Development</h3>
            <div className='experience__content'>
                  <article className='experience__details'>
                    <BsPatchCheckFill className='experience__details-icon'/>
                    <div>
                      <h4>Node JS</h4>
                      <small className='text-light'>Experienced</small>
                    </div>
                  </article>
                  <article className='experience__details'>
                    <BsPatchCheckFill className='experience__details-icon'/>
                    <div>
                      <h4>MYSQL</h4>
                      <small className='text-light'>Experienced</small>
                    </div>
                  </article>
                  <article className='experience__details'>
                    <BsPatchCheckFill className='experience__details-icon'/>
                    <div>
                      <h4>MONGODB</h4>
                      <small className='text-light'>intermediate</small>
                    </div>
                  </article>
                  <article className='experience__details'>
                    <BsPatchCheckFill className='experience__details-icon'/>
                    <div>
                      <h4>PHP</h4>
                      <small className='text-light'>Experienced</small>
                    </div>
                  </article>
                  <article className='experience__details'>
                    <BsPatchCheckFill className='experience__details-icon'/>
                    <div>
                      <h4>PYTHON</h4>
                      <small className='text-light'>basic</small>
                    </div>
                  </article>
            </div>
        </div>
      </div>
    </section>
  )
}

export default Experience